import { action as apiAction } from 'api/Api'
import { setName } from '../redux/checklistItems'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  cardId: number
  checklistItemId: number
  name: any
}

export default (payload: Payload) => async dispatch => {
  const { cardId, checklistItemId, name } = payload

  const optimisticAction = optimisticDispatch(dispatch, setName({
    cardId,
    checklistItemId: checklistItemId,
    name
  }))

  try {
    await apiAction('RenameChecklistItem', {
      id: checklistItemId,
      rtName: name
    })

    optimisticAction.commit()
  } catch (error) {
    optimisticAction.revert()

    if (error.code !== 303) {
      throw error
    }
  }
}
